import React, { useEffect, useState, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Button,
  CircularProgress,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Swal from "sweetalert2";
import { IoAdd } from "react-icons/io5";

import {
  getCustompageId,
  deleteCustomPageById,
} from "../../api/service/custompage.service";
import { showToast } from "../../components/common/ToastNotification/ToastNotification";

const CustomPageDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const fetchCustomPageById = useCallback(async () => {
    try {
      setLoading(true);
      const res = await getCustompageId(id);
      setPageData(res?.data || res || null);
    } catch (error) {
      console.error("Fetch error:", error);
      setPageData(null);
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    if (id) fetchCustomPageById();
  }, [fetchCustomPageById, id]);

  const handleDelete = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "This page will be permanently deleted!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d32f2f",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await deleteCustomPageById(pageData.id);
          showToast.success("Custom page deleted successfully");
          navigate(-1);
        } catch (error) {
          console.error("Delete error:", error);
          showToast.error("Failed to delete custom page");
        }
      }
    });
  };


  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
        <CircularProgress />
      </Box>
    );
  }


  if (!pageData) {
    return (
      <Box
        sx={{
          minHeight: "70vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: 2,
        }}
      >
        <Typography variant="h6" color="text.secondary">
          No data found
        </Typography>

        <Button
          variant="contained"
          startIcon={<IoAdd />}
          onClick={() => navigate(`/add-custompage/${id}`)}
          sx={{
            backgroundColor: "#C39B22",
            color: "#ffffff",
            textTransform: "none",
            fontWeight: 600,
            "&:hover": {
              backgroundColor: "#b18a1f",
            },
          }}
        >
          Add PageDetails
        </Button>
      </Box>
    );
  }

  return (
    <Box sx={{ maxWidth: "100%", mx: "auto", mt: 4 }}>
      <Card elevation={3}>
        <CardContent>
          {/* <label>Gallery Title</label> */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Typography
              variant="h5"
              fontWeight={600}
              className="management-tile"
            >
             Custom Banner Details
            </Typography>


            <Box sx={{ display: "flex", gap: 1 }}>
              <Button
                variant="contained"
                startIcon={<EditIcon />}
                onClick={() =>
                  navigate(`/update-custom-page/${pageData.id}`)
                }
                sx={{
                  backgroundColor: "#C39B22",
                  color: "#ffffff",
                  textTransform: "none",
                  fontWeight: 600,
                  "&:hover": {
                    backgroundColor: "#b18a1f",
                  },
                }}
              >
                Edit
              </Button>

              <Button
                variant="contained"
                color="error"
                startIcon={<DeleteIcon />}
                onClick={handleDelete}
                sx={{
                  textTransform: "none",
                  fontWeight: 600,
                }}
              >
                Delete
              </Button>
            </Box>
          </Box>

<Box sx={{ mt: 2 }}>
  <label className="form-label">Banner Title</label>
  <Typography 
    className="typography-box w-100">
    {pageData.title || "No Title Available"}
  </Typography>
</Box>

<Box sx={{ mt: 2 }}>
  <label className="form-label">Gallery Description</label>
  <Typography 
    className="typography-box w-100">
    {pageData.description || "No description available"}
  </Typography>
</Box>

          <Box style={{ display: "flex", justifyContent: "space-between" }}>
            <Box sx={{ mt: 4 }}>
              <Button
                variant="contained"

                onClick={() => navigate(`/features-list/${pageData.id}`)}
                sx={{
                  backgroundColor: "#C39B22",
                  color: "#ffffff",
                  textTransform: "none",
                  fontWeight: 600,
                  "&:hover": {
                    backgroundColor: "#b18a1f",
                  },
                }}
              >
                Features
              </Button>


              <Button className="ml-2"
                variant="contained"

                onClick={() => navigate(`/custom-gallerylist/${pageData.id}`)}
                sx={{
                  backgroundColor: "#C39B22",
                  color: "#ffffff",
                  textTransform: "none",
                  fontWeight: 600,
                  "&:hover": {
                    backgroundColor: "#b18a1f",
                  },
                }}
              >
                Gallery
              </Button>

            </Box>
          </Box>

        </CardContent>
      </Card>
    </Box>
  );
};

export default CustomPageDetails;